<template>
  <button
    :type="type"
    class="btn"
    :class="classes"
    :disabled="loading || disabled"
  >
    {{ title }}
    <span
      v-if="loading"
      class="spinner-grow spinner-grow-sm text-light"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </span>
  </button>
</template>

<script>
	export default {
		name: 'PrimaryButton',
		props: {
			loading: {
				type: Boolean,
				default: false,
			},
			title: {
				type: String,
				required: true,
			},
			classes: {
				type: String,
				default: '',
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			type: {
				type: String,
				default: 'submit',
			},
		},
	};
</script>
